<template>
  <div>
    <span v-html="descriptionToShow"></span>
    <template v-if="descriptionHasRest">
      <div v-if="collapsed" class="text-right text-read-more-less">
        <a class="text-muted font-weight-normal" @click="toggleCollapse" v-html="readMore"></a>
      </div>
      <div v-if="!collapsed" class="text-right text-read-more-less">
        <a class="text-muted font-weight-normal" @click="toggleCollapse" v-html="readLess"></a>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  data() {
    return {
      collapsed: true
    };
  },
  props: {
    stackLetter: {
      type: String,
      default: ''
    },
    readMore: {
      type: String,
      default: '&lt; En lire plus'
    },
    readLess: {
      type: String,
      default: '&gt; En lire moins'
    },
    descriptionLength: {
      type: Number,
      default: 150
    }
  },
  computed: {
    ...mapGetters([
      'paymentMethod',
      'recurrence',
      'choiceList',
      'choices'
    ]),
    id() {
      return `collapse-${this._uid}`;
    },
    choiceDescription() {
      const choice = this.choices.find(c => {
        if (c.paymentMethod === this.paymentMethod &&
            c.recurrence === this.recurrence &&
            c.stackLetter === this.stackLetter) {
          return true;
        }

        return false;
      });

      if (typeof choice !== 'undefined') {
        return choice.customHtml;
      }

      return '';
    },
    descriptionToShow() {
      let description = this.choiceDescription;

      if (this.choiceDescription.length >= this.descriptionLength && this.collapsed) {
        description = this.choiceDescription.slice(0, this.descriptionLength);
        description += '...';
      }

      return description;
    },
    descriptionHasRest() {
      return this.choiceDescription.length >= this.descriptionLength;
    }
  },
  methods: {
    toggleCollapse(event) {
      event.preventDefault();
      event.stopPropagation();
      this.collapsed = !this.collapsed;
    }
  }
};
</script>



// WEBPACK FOOTER //
// choice-description.vue?46922c05